<template>
  <div>
    <DataTable default-to-primera :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable"
               slot-name="second-last-column">
        <span slot="after-filters">
            <v-tooltip bottom>
                <v-btn slot="activator" icon @click="sendExcel" flat>
                    <v-icon color="primary">far fa-file-excel</v-icon>
                </v-btn>
                <span>Descargar XLS</span>
            </v-tooltip>
        </span>
      <template slot="second-last-column" slot-scope="props">
        <template v-if="noContracts(props.item)">
          <td colspan="4" class="text-xs-center table-row-no-contracts custom-font-regular" :key="'row'">No tiene contratos</td>
        </template>
        <template v-else>
          <td class="text-xs-center table-row" :key="'row-1'">
            <v-chip small text-color="white" color="green lighten-2">{{ props.item.verified }}</v-chip>
          </td>
          <td class="text-xs-center table-row" :key="'row-2'">
            <v-chip small text-color="grey darken-2" color="yellow">{{ props.item.pending }}</v-chip>
          </td>
          <td class="text-xs-center table-row" :key="'row-3'">
            <v-chip small text-color="white" color="red lighten-1">{{ props.item.rejected }}</v-chip>
          </td>
          <td class="text-xs-center table-row" :key="'row-4'">
            <v-chip small text-color="white" color="grey lighten-1">{{ props.item.ended }}</v-chip>
          </td>
        </template>
      </template>
    </DataTable>
    <v-snackbar v-model="sendEmailAlert" auto-height color="error">
      <span>En unos minutos recibirá el reporte a su correo electrónico</span>
      <v-btn icon @click="sendEmailAlert = false"><v-icon>close</v-icon></v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],

  components: {
    DataTable
  },

  data () {
    return {
      headers: [
        { text: 'Club', value: 'club', sortable: true, filterField: true },
        { text: 'Apellido', value: 'last_name', sortable: false },
        { text: 'Nombre', value: 'first_name', sortable: false },
        { text: 'Fecha Nacimiento', value: 'birth_day', sortable: false },
        { text: 'Edad', value: 'age', sortable: false },
        { text: 'Estado', value: 'player_status', sortable: false, filterField: true },
        { text: 'Estado Contractual', value: 'contractual_status', filterField: true, visible: false },
        { text: 'Última actualización', value: 'modified', sortable: false },
        { text: 'Contrato privado vigente', value: 'privateContract', sortable: false },
        { text: 'Cond. salariales contrato AFA', value: 'afa_contracts_salary_conditions', filterField: true, sortable: false },
        { text: 'Verificados', value: 'verified', sortable: false },
        { text: 'Pendientes', value: 'pending', sortable: false },
        { text: 'Rechazados', value: 'rejected', sortable: false },
        { text: 'Finalizados', value: 'ended', sortable: false }
      ],
      properties: ['club', 'playerLastName', 'playerFirstName', 'birthDay', 'age', 'status', 'modified', 'privateContract', 'afaContractsSalaryConditions'],
      path: 'contratos/list',
      filterPath: 'filters/players',
      sendEmailAlert: false
    }
  },

  methods: {
    noContracts (item) {
      return (item.verified + item.pending + item.rejected + item.ended) === 0
    },
    getExcelPath () {
      return 'contratos/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'contratos'
    },
    sendExcel () {
      this.axios
        .get(this.getExcelPath())
        .then((response) => {
          this.sendEmailAlert = true
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    }
  }
}

</script>

<style scoped>
    .table-row {
        background-color: white;
        border-bottom: 1px solid #959ba6;
    }
    .table-row-no-contracts {
        background-color: #d0caca;
        border-bottom: 1px solid #959ba6;
    }
</style>
